import isArray from 'lodash/isArray'

export const getDashboardKeyFn = ({
  subProductCode,
  programId,
}: {
  subProductCode: string
  programId?: string
}) => `${subProductCode}${programId ? `-${programId}` : ''}`

/**
 * Hydrate dashboard
 */
export const fixDashboardScopeFn = (dashboard: any) => {
  if (!dashboard) {
    return {}
  }
  const { components_settings: componentsSettings } = dashboard

  if (!componentsSettings) {
    return {
      components_settings: {},
    }
  }

  return {
    ...dashboard,
    components_settings: Object.keys(componentsSettings).reduce((acc, key) => {
      const subproductSettings = componentsSettings[key]
      if (!subproductSettings.filterBar) {
        acc[key] = subproductSettings
        return acc
      }

      const scopes = isArray(subproductSettings.filterBar.scopes)
        ? subproductSettings.filterBar.scopes
        : []

      acc[key] = {
        ...subproductSettings,
        filterBar: {
          ...subproductSettings.filterBar,
          scopes: scopes.filter(scope => Boolean(scope.id)), // Remove empty scopes
        },
      }
      return acc
    }, {}),
  }
}
